const resource = 'quicklinks'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  getServiceName: () => 'quickLinkService',
})
